import * as R from 'unitx/ramda';
import { useEffect, useRef, useState } from 'react';
export const useStateWithCallback = (initialState, callback = () => {}) => {
  const queue = useRef([]);
  const [state, setState] = useState(initialState);
  useEffect(() => {
    const currentQueue = [...queue.current];
    queue.current = [];
    R.forEach(callbackItem => {
      callbackItem(state);
    }, currentQueue);
    R.when(R.isFunction, // @ts-ignore
    () => callback(state))(callback);
  }, [state, callback]);
  return [state, // @ts-ignore
  (s, callbackItem) => {
    R.when(R.isFunction, // @ts-ignore
    () => {
      queue.current.push(callbackItem);
    })(callbackItem);
    setState(s);
  }];
};